export const getAccess = (permissions = {}, isAdmin = false) => {
  if (isAdmin) {
    return {
      pharmacy: true,
      finance: true,
      hr: true,
      is_staff: true,
    };
  }

  return {
    pharmacy: permissions.pharmacy || false,
    finance: permissions.finance || false,
    hr: permissions.hr || false,
    is_staff: permissions.is_staff || false,
  };
};
